"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlgoliaResults = void 0;
const lite_1 = require("dequal/lite");
const react_1 = require("react");
const useAlgoliaContext_1 = require("./useAlgoliaContext");
const types_1 = require("../types");
const useAlgoliaResults = (query) => {
    const { state, dispatch, error } = (0, useAlgoliaContext_1.useAlgoliaContext)();
    const results = state.results[query.id]?.results;
    (0, react_1.useEffect)(() => {
        if (!(0, lite_1.dequal)(state.queries[query.id], query)) {
            dispatch({
                type: types_1.AlgoliaActionType.UPDATE_QUERY,
                value: {
                    queryId: query.id,
                    query,
                },
            });
        }
    }, [dispatch, query, state.queries]);
    return {
        status: state.status,
        loading: state.status === types_1.AlgoliaStatus.LOADING,
        results: (!results ? query.initialState : results) ?? [],
        queryId: state.results[query.id]?.queryId,
        error,
    };
};
exports.useAlgoliaResults = useAlgoliaResults;
//# sourceMappingURL=useAlgoliaResults.js.map